import { InviteKey, ItemId, LiveId, SpaceKey, UserId, VoiceId, ShopCustomTagId, BrandId, SaleId, SystemNotificationId, PersonalNotificationId, StampCardId } from "../id"
import { RouteDefinition } from "./types"

export const publicRouteDefinitions = {
  users: {
    user: {
      pattern: "/users/:userId",
      params: { userId: UserId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ userId: UserId }>,

    follow: {
      pattern: "/users/:userId/follow",
      params: { userId: UserId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ userId: UserId }>,
  },

  spaces: {
    space: {
      pattern: "/spaces/:spaceKey",
      params: { spaceKey: SpaceKey },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ spaceKey: SpaceKey }>,

    live: {
      pattern: "/spaces/:spaceKey/lives/:liveId",
      params: { spaceKey: SpaceKey, liveId: LiveId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ spaceKey: SpaceKey; liveId: LiveId }>,
  },

  voices: {
    voice: {
      pattern: "/voices/:userId/:voiceId",
      params: { userId: UserId, voiceId: VoiceId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ userId: UserId; voiceId: VoiceId }>,
  },

  shop: {
    top: {
      pattern: "/shop",
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition,

    search: {
      pattern: "/shop/search",
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition,

    item: {
      pattern: "/shop/items/:itemId",
      params: { itemId: ItemId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ itemId: ItemId }>,

    customTag: {
      pattern: "/shop/custom-tags/:customTagId",
      params: { customTagId: ShopCustomTagId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ customTagId: ShopCustomTagId }>,

    brand: {
      pattern: "/shop/brands/:brandId",
      params: { brandId: BrandId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ brandId: BrandId }>,

    collection: {
      pattern: "/shop/collections/:collectionId",
      params: { collectionId: SaleId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ collectionId: SaleId }>,
  },

  invites: {
    friends: {
      pattern: "/users/:userId/invites/:inviteKey",
      params: { userId: UserId, inviteKey: InviteKey },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ userId: UserId; inviteKey: InviteKey }>,

    spaces: {
      pattern: "/spaces/:spaceKey/invites/:inviteKey",
      params: { spaceKey: SpaceKey, inviteKey: InviteKey },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ spaceKey: SpaceKey; inviteKey: InviteKey }>,
  },

  premium: {
    pattern: "/premium",
    needsSSR: true,
    supportsRedirect: true,
  } satisfies RouteDefinition,

  notifications: {
    system: {
      pattern: "/notifications/system",
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition,

    systemNotification: {
      pattern: "/notifications/system/:notificationId",
      params: { notificationId: SystemNotificationId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ notificationId: SystemNotificationId }>,

    personal: {
      pattern: "/notifications/personal",
      needsSSR: false,
      supportsRedirect: false,
    } satisfies RouteDefinition,

    personalNotification: {
      pattern: "/notifications/personal/:notificationId",
      params: { notificationId: PersonalNotificationId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ notificationId: PersonalNotificationId }>,
  },

  top: {
    pattern: "/top",
    needsSSR: true,
    supportsRedirect: true,
  } satisfies RouteDefinition,

  my: {
    inventory: {
      pattern: "/my/inventory",
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition,

    stampCards: {
      pattern: "/my/stamp-cards",
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition,

    stampCard: {
      pattern: "/my/stamp-cards/:stampCardId",
      params: { stampCardId: StampCardId },
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition<{ stampCardId: StampCardId }>,

    histories: {
      pattern: "/my/histories",
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition,

    following: {
      pattern: "/my/following",
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition,

    notifications: {
      pattern: "/my/notifications",
      needsSSR: true,
      supportsRedirect: true,
    } satisfies RouteDefinition,
  },

  news: {
    pattern: "/news",
    needsSSR: true,
    supportsRedirect: true,
  } satisfies RouteDefinition,

  about: {
    pattern: "/about",
    needsSSR: true,
    supportsRedirect: true,
  } satisfies RouteDefinition,

  contact: {
    pattern: "/contact",
    needsSSR: true,
    supportsRedirect: true,
  } satisfies RouteDefinition,
}
